import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { PermissionService } from "./permission-service";

export const permissionApi = createApi({
  reducerPath: "permissionApi",
  baseQuery: createBaseQuery(""),
  tagTypes: ["PermissionGroup"],
  endpoints: (build) => ({
    listPermissionGroups: build.query<
      CompanyPermissionGroup[],
      PermissionListParams
    >({
      query: (params) => ({
        url: PermissionService.getEndpointUrl(params),
        method: "GET",
        params: { search: params.search },
      }),
      providesTags: ["PermissionGroup"],
    }),

    createPermissionGroup: build.mutation<
      CompanyPermissionGroup,
      { companyId: number; data: PermissionGroupData }
    >({
      query: ({ data, ...params }) => ({
        url: PermissionService.getEndpointUrl(params),
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PermissionGroup"],
    }),

    updatePermissionGroup: build.mutation<
      CompanyPermissionGroup,
      { companyId: number; permissionId: number; data: PermissionGroupData }
    >({
      query: ({ data, ...params }) => ({
        url: PermissionService.getEndpointUrl(
          params,
          `/${params.permissionId}`
        ),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["PermissionGroup"],
    }),

    deletePermissionGroup: build.mutation<
      void,
      { companyId: number; permissionId: number }
    >({
      query: (params) => ({
        url: PermissionService.getEndpointUrl(
          params,
          `/${params.permissionId}`
        ),
        method: "DELETE",
      }),
      invalidatesTags: ["PermissionGroup"],
    }),

    listCompanyResources: build.query<
      CompanyPermissionRole[],
      { companyId: number; groupId?: number }
    >({
      query: (params) => ({
        url: PermissionService.getEndpointUrl(params, `/resources`),
        method: "GET",
        params: { groupId: params.groupId },
      }),
      providesTags: ["PermissionGroup"],
    }),
  }),
});
